import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../constants/launch";

export const STORE_PLATFORM = {
  IOS: "ios",
  ANDROID: "android",
  OTHER: "other",
};

export function detectStorePlatform({
  userAgent = "",
  platform = "",
  maxTouchPoints = 0,
} = {}) {
  const normalizedUserAgent = userAgent || "";
  const normalizedPlatform = platform || "";
  const isIOSDevice =
    /iPad|iPhone|iPod/i.test(normalizedUserAgent) ||
    (normalizedPlatform === "MacIntel" && maxTouchPoints > 1);

  if (isIOSDevice) return STORE_PLATFORM.IOS;
  if (/Android/i.test(normalizedUserAgent)) return STORE_PLATFORM.ANDROID;
  return STORE_PLATFORM.OTHER;
}

export function getStoreUrlForPlatform(platform) {
  if (platform === STORE_PLATFORM.IOS) return APP_STORE_URL;
  if (platform === STORE_PLATFORM.ANDROID) return GOOGLE_PLAY_URL;
  return null;
}
